import Skeleton from '@mui/material/Skeleton';
import type { JSX } from 'react';

import styles from './CountCallout.module.css';

/**
 * @param count - The number to display in the callout.
 * @param countHighlight - If this is `true` and the count is greater than zero, the count will be highlighted (i.e., given a yellow-green color). This is `true` only for "Overdue Assessments", where the number gets highlighted if there are any overdue assessments.
 * @param onclick - The function to call when the callout is clicked.
 */
interface CountCalloutProps {
    count?: number;
    countHighlight?: boolean;
    onclick?: () => void;
}

/**
 * Displays a number that the user can click.
 * Used on the TPRM and UCRM dashboards to display the numbers of active organizations, active assessment subjects, and overdue due diligence workflows.
 *
 * TODO: Be consistent with clicks on the TPRM and UCRM dashboards. Clicking on the numbers of active organizations or active assessment subjects takes the user to the module's listing page, while clicking on anything else (including Overdue Assessments) opens a modal.
 * * These "links" also break our standards, as this component renders as a button, which means the user cannot hover over the text to see the hyperlink, or right-click to open in a new tab.
 */
export const CountCallout = (props: CountCalloutProps): JSX.Element => {
    return (
        <div onClick={props.onclick} className={styles.container}>
            {props.count !== undefined ? (
                <div className={props.countHighlight && props.count > 0 ? styles.countHighlight : styles.count}>{props.count}</div>
            ) : (
                <div className={styles.skeleton}>
                    <Skeleton>
                        <div className={styles.count}>---</div>
                    </Skeleton>
                </div>
            )}
        </div>
    );
};
